/** 获取 block 信息 */
import { useObservableBlock } from 'src/services/rxjs-redux/hook';

/** 推荐使用usePickBlock,只拿自己感兴趣的字段 */
export const useBlock = (uuid: string | undefined) => {
  return useObservableBlock(uuid);
};
